module.exports = __webpack_public_path__ + "media/images/large_x_icon_2-50ca507f.svg";